import React from "react";
import { Route } from "react-router-dom";
import { Redirect } from "react-router";
import { fetchCookie } from "services/cookieService";

export function ProtectedRoute({ children, ...rest }) {
    let cookie = fetchCookie();
    return (
        cookie ? <Route {...rest}>{children}</Route> : <Redirect
            to={{
                pathname: "/login",
            }}
        />
    );
}